import React from 'react';
import { FaSadTear } from 'react-icons/fa';

const NoFlights = ({ isArrival = false }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 
      bg-gradient-to-br from-[#0B1E34] via-[#132F4C] to-[#0B1E34]
      rounded-2xl shadow-2xl mt-8 border border-white/10
      backdrop-blur-md text-white">

      <div className="bg-white/10 p-6 rounded-full shadow-lg border border-white/20">
        <FaSadTear className="text-5xl text-teal-300 mb-1 animate-bounce" />
      </div>

      <h2 className="text-2xl font-bold mt-4 text-teal-300">
        {isArrival ? 'No Return Flights Found' : 'No Flights Found'}
      </h2>

      <p className="text-gray-200 text-center max-w-md mt-3">
        We couldn’t find any flights matching your search criteria.  
        Try adjusting your dates or destinations and search again.
      </p>
    </div>
  );
};

export default NoFlights;
